export default __webpack_public_path__ + "media/color/usdc-181a0b4d.svg";